 export const FORM_REGEX = {
    EMAIL:  /^\S+@\S+\.\S+$/,
    NAME: /^[\w&`'. -]{2,60}$/g
}
